import script from "./EditPortfolioForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditPortfolioForm.vue?vue&type=script&setup=true&lang=js"

import "./EditPortfolioForm.vue?vue&type=style&index=0&id=dfc5a85c&lang=scss"

const __exports__ = script;

export default __exports__